import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {  getCertificateById } from "../../../../redux/features/certificate/certificateService";
import NoResultsFound from "../../../../components/NoResultsFound";
import GridLoader from "react-spinners/GridLoader";
import IBSUOfficialCertificateImage from "../../../../components/Certificate/IBSUCertificate/IBSUOfficial/IBSUOfficialCertificateImage";
import IBSCOfficialCertificateImage from "../../../../components/Certificate/IBSCCertificate/IBSCOfficial/IBSCOfficialCertificateImage";
import CDCCertificateImage from "../../../../components/Certificate/CDCCertificate/CDCOther/CDCCertificateImage";

const PreviewCertificate = () => {
    const { certificate_id } = useParams();
    const dispatch = useDispatch();

    const { isLoadingCertificateDetails, isCertificateDetailsSuccess, certificate } = useSelector((state) => state.certificate.certificateDetails);

    const [certificateImage, setCertificateImage] = useState(null);

    useEffect(() => {
        dispatch(getCertificateById({ certificate_id })).unwrap();
    }, [dispatch, certificate_id]);

    return (
        <div className={`main-card`}>
            {isLoadingCertificateDetails ? (
                <div className={`loader-style`}>
                    <GridLoader color="#df771c" />
                </div>
            ) : !isCertificateDetailsSuccess ? (
                <NoResultsFound />
            ) : (
                <>
                    {certificate?.certificate_template?.name === 'IBSU Offical Certificate' ?
                        <IBSUOfficialCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                        : certificate?.certificate_template?.name === 'IBSC Official Certificate' ?
                            <IBSCOfficialCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                            :
                            <CDCCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                    }
                    {certificateImage !== null ? (
                        <div>
                            <div className={`form-input-row`}>Certificate Preview
                            </div>
                            <img src={certificateImage} alt="Certificate Preview" style={{ width: "100%", maxWidth: "400px", border: "1px solid #ccc" }} />
                        </div>
                    ) : <div className={`loader-style`}>
                        <GridLoader color="#df771c" />
                    </div>}
                </>
            )}
        </div>
    );
};
export default PreviewCertificate;
